import {pickAll, pipe} from 'ramda'
import renamePropName from 'utils/renamePropName'

import {
  UrlCheckoutParamsType,
  UrlSearchParamsType
} from '@vio/core/src/utils/url/types/UrlParams'

const paramsKeys = ['hotelId', 'checkIn', 'checkOut', 'rooms', 'oid'] as const

const searchWebsiteParams = pipe(
  pickAll(paramsKeys),
  renamePropName('locale', 'lang')
) as unknown as (params: UrlCheckoutParamsType) => UrlSearchParamsType

export default searchWebsiteParams
